import { Tabs, Image } from "antd";
import { useState } from "react";
import tabImg from "../assets/images/tourTabIcon.svg";
import { ReactComponent as DoubleCheck } from "../assets/images/doubleCheck.svg";

const TourInclusionsTabs = ({ sections = [] }) => {
  const [activeKey, setActiveKey] = useState("1");

  const renderChildren = (children = []) => {
    return children.map((child, cIdx) => {
      // LINK
      if (child.type === "link") {
        return (
          <a
            key={cIdx}
            href={child.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary font-medium hover:opacity-80"
          >
            {child.children?.map((linkChild, linkIdx) => (
              <span key={linkIdx}>
                {linkChild.text}
              </span>
            ))}
          </a>
        );
      }

      // BOLD TEXT
      if (child.bold) {
        return (
          <strong key={cIdx} className="font-semibold">
            {child.text}
          </strong>
        );
      }

      // NORMAL TEXT
      return (
        <span key={cIdx}>
          {child.text}
        </span>
      );
    });
  };

  // Helper: Render each content paragraph block from Strapi JSON
  const renderSectionContent = (section) => {
    if (!section?.content?.length) return null;

    return (
      <div className="space-y-2 text-sm text-black">
        {section.content.map((block, idx) => {
          // LIST
          if (block.type === "list") {
            return (
              <ul key={idx} className="space-y-2">
                {block.children?.map((item, i) => (
                  <li key={i} className="flex gap-2 font-normal">
                    <DoubleCheck className="mt-1 shrink-0" />

                    <span>
                      {renderChildren(item.children)}
                    </span>
                  </li>
                ))}
              </ul>
            );
          }

          // PARAGRAPH
          if (block.type === "paragraph") {
            return (
              <p key={idx} className="font-normal">
                {renderChildren(block.children)}
              </p>
            );
          }

          // HEADING
          if (block.type === "heading") {
            const Tag = `h${block.level || 3}`;

            return (
              <Tag key={idx} className="font-semibold">
                {renderChildren(block.children)}
              </Tag>
            );
          }

          return null;
        })}
      </div>
    );
  };

  // Build tabs dynamically based on API response
  const tabItems = [
    {
      key: "0",
      disabled: true,
      label: (
        <span className="pb-2 text-base">
          <Image preview={false} src={tabImg} />
        </span>
      ),
    },
    ...sections.map((section, index) => ({
      key: `${index + 1}`,
      label: (
        <span
          className={`pb-2 text-sm ${activeKey === `${index + 1}`
            ? "text-danger font-semibold"
            : "text-gray-900 font-normal"
            }`}
        >
          {section.title?.trim() || `Section ${index + 1}`}
        </span>
      ),
      children: renderSectionContent(section),
    })),
  ];

  return (
    <div className="">
      <Tabs
        activeKey={activeKey}
        onChange={setActiveKey}
        defaultActiveKey="1"
        items={tabItems}
        className=" 
          [&_.ant-tabs-nav]:border-t
          [&_.ant-tabs-nav]:mb-0
          [&_.ant-tabs-nav]:pl-3
          [&_.ant-tabs-tab]:outline-none 
          [&_.ant-tabs-tab]:!m-0 
          [&_.ant-tabs-ink-bar]:hidden
          [&_.ant-tabs-tab-btn]:border-r 
          [&_.ant-tabs-tab-btn]:px-6 
          [&_.ant-tabs-tab-btn]:border-gray-200
          [&_.ant-tabs-tab]:shadow-none 
          [&_.ant-tabs-tab:focus]:outline-none 
          [&_.ant-tabs-tab:focus]:shadow-none 
          [&_.ant-tabs-tab.ant-tabs-tab-active]:shadow-none 
          [&_.ant-tabs-content-holder]:px-8 [&_.ant-tabs-content-holder]:py-8
          [&_.ant-tabs-content-holder]:border-l [&_.ant-tabs-content-holder]:border-r [&_.ant-tabs-content-holder]:border-b 
        "
      />
    </div>
  );
};

export default TourInclusionsTabs;
